import { useTranslation } from "react-i18next";

import View from "components/elements/View";

function Shipping(): JSX.Element {
  const { t } = useTranslation();

  return (
    <View title={t("shipping.title")}>
      <p>Versand</p>
    </View>
  );
}

export default Shipping;
